// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__input {
  position: relative;
  display: flex;
  align-items: center;
  height: 36px;
  background: #ffffff;
  font-size: 13px;
}
.avo__input.input-area {
  align-items: flex-start;
  height: -moz-fit-content;
  height: fit-content;
}
.avo__input .input-wrapper {
  width: 100%;
  position: relative;
  display: flex;
}
.avo__input .input-wrapper-area {
  flex-direction: column;
  align-items: end;
  gap: 12px;
}
.avo__input .input-wrapper-area .count-char {
  color: #788192;
}
.avo__input .input-wrapper input,
.avo__input .input-wrapper textarea {
  width: 100%;
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
  font-family: "OpenSans-Regular";
  color: #101728;
  padding: 8px 12px;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid #cdd5df;
}
.avo__input .input-wrapper input {
  overflow: hidden;
}
.avo__input .input-wrapper textarea {
  overflow-y: auto;
}
.avo__input .input-wrapper input.with-addon-before,
.avo__input .input-wrapper textarea.with-addon-before {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.avo__input .input-wrapper input.with-addon-after,
.avo__input .input-wrapper textarea.with-addon-after {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.avo__input .input-wrapper input:hover,
.avo__input .input-wrapper textarea:hover {
  border-color: #97a2b6;
}
.avo__input .input-wrapper input:focus,
.avo__input .input-wrapper textarea:focus {
  border-color: #2d96be;
  box-shadow: 0px 0px 0px 2px rgba(17, 101, 132, 0.25);
}
.avo__input .input-wrapper input.invalid,
.avo__input .input-wrapper textarea.invalid {
  border-color: #f04438;
  box-shadow: 0px 0px 0px 2px rgba(240, 68, 56, 0.2509803922);
}
.avo__input .input-wrapper input::placeholder,
.avo__input .input-wrapper textarea::placeholder {
  color: #788192;
}
.avo__input .input-wrapper input:disabled,
.avo__input .input-wrapper textarea:disabled {
  border-color: #cdd5df;
  background: #f9fafb;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  color: #97a2b6;
}
.avo__input .input-wrapper .btn-clear {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
}
.avo__input .input-wrapper .btn-clear.include-icon-after {
  right: 35px;
}
.avo__input .input-wrapper .btn-password-visible {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms;
  opacity: 0.5;
}
.avo__input .input-wrapper .btn-password-visible:hover {
  opacity: 1;
}
.avo__input .input-wrapper .btn-password-visible:hover + input {
  border-color: #97a2b6;
}
.avo__input .input-wrapper .btn-password-visible + input {
  padding-right: 32px;
}
.avo__input img {
  width: 16px;
  height: 16px;
}
.avo__input .addon {
  background: #f9fafb;
  border: 1px solid #cdd5df;
  padding: 8px 24px;
  font-family: "OpenSans-Medium";
  color: #0a0a0a;
}
.avo__input .addon.disabled {
  color: #97a2b6;
}
.avo__input .addon-before {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 0px;
}
.avo__input .addon-after {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/input/input.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBCPI;EDQJ,eAAA;AADJ;AAGI;EACI,uBAAA;EACA,wBAAA;EAAA,mBAAA;AADR;AAII;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAFR;AAIQ;EACI,sBAAA;EACA,gBAAA;EACA,SAAA;AAFZ;AAIY;EACI,cChBH;ADcb;AAMQ;;EAEI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,cC1BC;ED2BD,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AAJZ;AAOQ;EACI,gBAAA;AALZ;AAQQ;EACI,gBAAA;AANZ;AAagB;;EACI,2BAAA;EACA,8BAAA;AAVpB;AAYgB;;EACI,4BAAA;EACA,+BAAA;AATpB;AAaY;;EACI,qBC3DH;ADiDb;AAYY;;EACI,qBCrDH;EDsDG,oDAAA;AAThB;AAWY;;EACI,qBCxEV;EDyEU,2DAAA;AARhB;AAUY;;EACI,cCrEH;AD8Db;AASY;;EACI,qBC3EH;ED4EG,mBC9EH;ED+EG,+CAAA;EACA,cC5EH;ADsEb;AAUQ;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AARZ;AAUY;EACI,WAAA;AARhB;AAYQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,8CAAA;EACA,YAAA;AAVZ;AAYY;EACI,UAAA;AAVhB;AAWgB;EACI,qBCzGP;ADgGb;AAYY;EACI,mBAAA;AAVhB;AAeI;EACI,WAAA;EACA,YAAA;AAbR;AAgBI;EACI,mBC5HK;ED6HL,yBAAA;EACA,iBAAA;EACA,8BAAA;EACA,cCxHK;AD0Gb;AAgBQ;EACI,cC/HC;ADiHb;AAiBQ;EACI,2BAAA;EACA,8BAAA;EACA,iBAAA;AAfZ;AAiBQ;EACI,4BAAA;EACA,+BAAA;EACA,gBAAA;AAfZ","sourcesContent":["@import '../../../styles/color';\n\n.avo__input {\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 36px;\n    background: $white;\n    font-size: 13px;\n\n    &.input-area {\n        align-items: flex-start;\n        height: fit-content;\n    }\n\n    .input-wrapper {\n        width: 100%;\n        position: relative;\n        display: flex;\n\n        &-area {\n            flex-direction: column;\n            align-items: end;\n            gap: 12px;\n\n            .count-char {\n                color: $neutral-60;\n            }\n        }\n\n        input,\n        textarea {\n            width: 100%;\n            appearance: none;\n            outline: none;\n            border: none;\n            box-shadow: none;\n            font-family: 'OpenSans-Regular';\n            color: $neutral-80;\n            padding: 8px 12px;\n            gap: 12px;\n            border-radius: 8px;\n            border: 1px solid $neutral-30;\n        }\n\n        input {\n            overflow: hidden;\n        }\n\n        textarea {\n            overflow-y: auto;\n        }\n\n        input,\n        textarea {\n\n            &.with-addon {\n                &-before {\n                    border-top-left-radius: 0px;\n                    border-bottom-left-radius: 0px;\n                }\n                &-after {\n                    border-top-right-radius: 0px;\n                    border-bottom-right-radius: 0px;\n                }\n            }\n\n            &:hover {\n                border-color: $neutral-50;\n            }\n            &:focus {\n                border-color: $primary-40;\n                box-shadow: 0px 0px 0px 2px rgba($primary, 0.25);\n            }\n            &.invalid {\n                border-color: $red;\n                box-shadow: 0px 0px 0px 2px $red-shadow;\n            }\n            &::placeholder {\n                color: $neutral-60;\n            }\n            &:disabled {\n                border-color: $neutral-30;\n                background: $neutral-10;\n                box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);\n                color: $neutral-50;\n            }\n        }\n\n        .btn-clear {\n            position: absolute;\n            top: 50%;\n            right: 12px;\n            transform: translateY(-50%);\n\n            &.include-icon-after {\n                right: 35px;\n            }\n        }\n\n        .btn-password-visible {\n            position: absolute;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            top: 50%;\n            transform: translateY(-50%);\n            right: 12px;\n            transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms;\n            opacity: 0.5;\n\n            &:hover {\n                opacity: 1;\n                + input {\n                    border-color: $neutral-50;\n                }\n            }\n            + input {\n                padding-right: 32px;\n            }\n        }\n    }\n\n    img {\n        width: 16px;\n        height: 16px;\n    }\n\n    .addon {\n        background: $neutral-10;\n        border: 1px solid $neutral-30;\n        padding: 8px 24px;\n        font-family: 'OpenSans-Medium';\n        color: $neutral-90;\n\n        &.disabled {\n            color: $neutral-50;\n        }\n\n        &-before {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n            border-right: 0px;\n        }\n        &-after {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n            border-left: 0px;\n        }\n    }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
